import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";

/**
 * 제목 : 이미지용 아바타 배너
 * 참고 Url : https://mui.com/material-ui/react-avatar/#main-content
 * params :
 *  alt : 이미지 설명
 *  src : 이미지 url
 *  width : 이미지 넓이
 *  height: 이미지 높이
 */
export const DefaultAvatar = ({
  alt = "이미지",
  src = null,
  width = 80,
  height = 80,
}) => {
  return <Avatar alt={alt} src={src} sx={{ width: width, height: height }} />;
};

DefaultAvatar.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string || null,
  width: PropTypes.number,
  height: PropTypes.number,
};
